import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  Pipe,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-page-selector',
  templateUrl: './page-selector.component.html',
  styleUrls: ['./page-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageSelectorComponent implements OnInit {
  @Input() unitImage: string;
  @Input() pages;
  @Output() emitSelection = new EventEmitter();
  selection = null;
  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.pages = this.pages.results;
    const dayNumber = this.route.snapshot.paramMap.get('dayNumber');
    this.selection = parseInt(dayNumber, 10);
  }

  public goBack(): void {
    const url = this.router.url.split('/');
    if (url.includes('admin')) {
      url.pop();
      url.pop();
      url.pop();
    } else {
      url.pop();
    }

    const newUrl = url.join('/');
    this.router.navigate([newUrl]);
  }

  onSelection() {
    if (this.selection !== null) this.emitSelection.emit(this.selection);
  }
}
